import moment from 'moment-timezone';

export const updateTimeFormatterUTC = ({ value }) => moment(value).utc().format('HH:mm');
